<script setup lang="ts">
import { Menu } from '@types';
import useDialogStore from '@/stores/dialog';
import ChevronUpLightIcon from '@/icons/ChevronUpLightIcon.vue';
import ChevronDownLightIcon from '@/icons/ChevronDownLightIcon.vue';

// Instances
const dialogStore = useDialogStore();

// Properties
const props = withDefaults(defineProps<{
    item: Menu,
    open?: boolean,
    block?: boolean,
    wordBreak?: boolean,
}>(), {
    open: false,
    block: false,
    wordBreak: false,
});

// Computed
const isDropDown = computed<boolean>(() => props.item.items.length > 0);
const isRoute = computed<boolean>(() => props.item.type === 'page');

const componentProps = computed<{ [key: string]: any }>(() => {
    const temp: { [key: string]: any } = {};

    if (isDropDown.value) {
        return temp;
    }

    if (isRoute.value) {
        temp.to = {name: props.item.link};
    } else {
        temp.href = `#${props.item.link}`;
    }

    return temp;
});

// Methods
const onButtonClick = (event: PointerEvent): void => {
    if (props.item.type !== 'dialog') {
        return;
    }

    event.preventDefault();

    dialogStore.open(props.item.link);
};
</script>

<template>
    <Component
        :is="isDropDown ? 'div' : (isRoute ? 'RouterLink' : 'a')"
        v-bind="componentProps"
        class="select-none"
        :class="{'block': block, 'inline-block': !block}"
        @click="onButtonClick"
    >
        <SecondaryButton
            class="flex items-center justify-center space-x-2"
            :class="{'w-full': block}"
        >
            <div :class="{'whitespace-nowrap': !wordBreak}">
                {{ item.title }}
            </div>

            <template v-if="isDropDown">
                <ChevronUpLightIcon
                    v-if="open"
                    class="block w-3 h-3 shrink-0"
                />
                <ChevronDownLightIcon
                    v-else
                    class="block w-3 h-3 shrink-0"
                />
            </template>
        </SecondaryButton>
    </Component>
</template>

<style scoped>

</style>
